'use client';

import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { AnnouncementBar } from './announcement-bar';
import { useHeaderRuntime } from './header-runtime';
import type { AnnouncementBarMessage } from './site-header.shared';
import { SiteHeaderAnnouncementBar } from './site-header-announcement-bar';
interface HeaderAnnouncementProps {
  /** Messages computed from the static (CMS) cart settings. */
  messages: AnnouncementBarMessage[];
  enabled: boolean;
  style?: CSSProperties;
}

/**
 * Announcement bar that renders from the static shell's messages and switches
 * to the runtime-overlaid messages in place once they stream in (see
 * header-runtime.tsx) — no second header, no DOM swap.
 */
export function HeaderAnnouncement(t0) {
  const $ = _c(3);
  const {
    messages,
    enabled,
    style
  } = t0;
  const runtime = useHeaderRuntime();
  const effectiveMessages = runtime?.announcementMessages ?? messages;
  if (!enabled || effectiveMessages.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== effectiveMessages || $[1] !== style) {
    t1 = effectiveMessages.length > 1 ? <SiteHeaderAnnouncementBar messages={effectiveMessages} style={style} /> : <AnnouncementBar messages={effectiveMessages} style={style} />;
    $[0] = effectiveMessages;
    $[1] = style;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}